import React, { createContext, useState, ReactNode, useContext } from "react";
import {
  ClientOptionListResponseModel,
  createUpdateProjectClientPayloadModel,
  createupdateResopnsePayload,
  getclientdetailpayload,
  getclientDetailResponseModel,
  getclientlistResponseModel,
  getClientProjectOptionResponseModel,
} from "../model/clientmodel";
import useClientApi from "../api/client";
import { getUserIdTokenForIonTime } from "../helper/api";
import { useNavigate } from "react-router-dom";
import useProjectApi from "../api/project";
import {
  createProjectUserPayloadModel,
  deleteuserInProject,
  exportTeamOptionResponse,
  ProjectDetailResponse,
  updateProjectActivityPayload,
} from "../model/projectModel";

interface ManageClientContextType {
  projectFormType: string;
  setProjectFormType: (item: string) => void;
  clientId: number | null;
  setClientID: (clientId: number | null) => void;
  clientFormType: string;
  setClientFormType: (item: string) => void;
  clientList: getclientlistResponseModel[] | null;
  setClientList: (item: getclientlistResponseModel[] | null) => void;
  clientDetails: getclientDetailResponseModel | null;
  setClientDetails: (item: getclientDetailResponseModel | null) => void;
  clientPageOption: ClientOptionListResponseModel | null;
  setClientPageOption: (item: ClientOptionListResponseModel | null) => void;
  projectOptions: getClientProjectOptionResponseModel | null;
  projectDetail: ProjectDetailResponse | null;
  setProjectDetail: (item: ProjectDetailResponse | null) => void;
  memberOptionDetail: exportTeamOptionResponse | null;
  setsMemberOptionDetail: (item: exportTeamOptionResponse | null) => void;
  setProjectOptions: (item: getClientProjectOptionResponseModel | null) => void;
  getClientOption: () => void;
  getProjectOption: () => void;
  getClientlist: (status: string) => void;
  getClientDetails: (item: getclientdetailpayload) => void;
  addandupdateClient: (item: createupdateResopnsePayload) => void;
  addandupdateClientProject: (item: createUpdateProjectClientPayloadModel) => void;
  getProjectDetails: (item: number) => void;
  updateProjectActivity: (item: updateProjectActivityPayload[]) => void;
  addProjectActivity: (item: updateProjectActivityPayload[]) => void;
  editProjectActivity: (projects_id: number, version_id: number, activity_name: string) => Promise<void>;
  deleteProjectActivity: (projects_id: number, version_id: number) => Promise<void>;
  toggleMandatoryActivity: (projects_id: number, version_id: number) => Promise<void>;
  addProjectMember: (item: createProjectUserPayloadModel) => void;
  deleteProjectMember: (item: deleteuserInProject) => void;
}

const defaultManageClientContext: ManageClientContextType = {
  clientId: null,
  setClientID: () => { },
  clientFormType: "update",
  setClientFormType: () => { },
  clientList: null,
  setClientList: () => { },
  clientDetails: null,
  setClientDetails: () => { },
  clientPageOption: null,
  setClientPageOption: () => { },
  projectOptions: null,
  setProjectOptions: () => { },
  projectDetail: null,
  setProjectDetail: () => { },
  projectFormType: "update",
  setProjectFormType: () => { },
  memberOptionDetail: null,
  setsMemberOptionDetail: () => { },
  getClientOption: () => { },
  getProjectOption: () => { },
  getClientlist: () => { },
  getClientDetails: () => { },
  addandupdateClient: () => { },
  addandupdateClientProject: () => { },
  getProjectDetails: () => { },
  updateProjectActivity: () => { },
  addProjectActivity: async () => { },
  editProjectActivity: async () => { },
  deleteProjectActivity: async () => { },
  toggleMandatoryActivity: async () => { },
  addProjectMember: () => { },
  deleteProjectMember: () => { },
};

const ManageClientContext = createContext<ManageClientContextType>(defaultManageClientContext);

export const ManageClientProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [clientId, setClientID] = useState<number | null>(null);
  const [clientFormType, setClientFormType] = useState<string>("update");
  const [projectFormType, setProjectFormType] = useState<string>("update");
  const [clientList, setClientList] = useState<getclientlistResponseModel[] | null>(null);
  const [clientDetails, setClientDetails] = useState<getclientDetailResponseModel | null>(null);
  const [clientPageOption, setClientPageOption] = useState<ClientOptionListResponseModel | null>(null);
  const [projectOptions, setProjectOptions] = useState<getClientProjectOptionResponseModel | null>(null);
  const [projectDetail, setProjectDetail] = useState<ProjectDetailResponse | null>(null);
  const [memberOptionDetail, setsMemberOptionDetail] = useState<exportTeamOptionResponse | null>(null);

  const navigate = useNavigate();
  const getUserId = getUserIdTokenForIonTime();

  const {
    fetchGetClientOptionList,
    fetchGetProjectOption,
    fetchGetClientList,
    fetchGetClientDetail,
    createupdateClient,
    createupdateClientProject,
  } = useClientApi();
  const {
    fetchGetPromiseProjectDetail,
    updateProjectActivityApi,
    addProjectActivityApi,
    editProjectActivityApi,
    deleteProjectActivityApi,
    toggleMandatoryActivityApi,
    createProjectUser,
    fetchDeleteUserInProject,
  } = useProjectApi();

  const getClientOption = React.useCallback(async () => {
    if (getUserId) {
      try {
        const responseData = await fetchGetClientOptionList(Number(getUserId));
        setClientPageOption(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    }
  }, [fetchGetClientOptionList, getUserId]);

  const getClientlist = React.useCallback(async (status: string) => {
    try {
      const responseData = await fetchGetClientList(Number(getUserId), Number(status));
      setClientList(responseData);
    } catch (error) {
      // setError(error.message);
    }
  }, []);

  const getClientDetails = React.useCallback(async (payload: getclientdetailpayload) => {
    try {
      const response = await fetchGetClientDetail(payload);
      setClientPageOption(response?.options ?? null);
      setClientDetails(response);
    } catch (error) {
      // setError(error.message);
    }
  }, []);

  const addandupdateClient = React.useCallback(
    async (user: createupdateResopnsePayload) => {
      try {
        const response = await createupdateClient(user);
        getClientlist("0");
        navigate("/client");
        return response;
      } catch (error) {
        //   setError(error.message);
      }
    },
    [createupdateClient, getClientlist, navigate],
  );

  const addandupdateClientProject = React.useCallback(
    async (project: createUpdateProjectClientPayloadModel) => {
      try {
        const response = await createupdateClientProject(project);
        navigate(-1);
        return response;
      } catch (error) {
        //   setError(error.message);
      }
    },
    [createupdateClientProject, navigate],
  );

  const getProjectOption = React.useCallback(async () => {
    try {
      const response = await fetchGetProjectOption();
      setProjectOptions(response);
      return response;
    } catch (error) {
      // setError(error.message);
    }
  }, []);

  // const getMemberOptionsDetails = React.useCallback(
  //   async (projectID: number) => {
  //     try {
  //       const response = await fetchTeamOptionDetail(projectID);
  //       setsMemberOptionDetail(response);
  //       return response;
  //     } catch (error) {
  //       // setError(error.message);
  //     }
  //   },
  //   [fetchTeamOptionDetail],
  // );

  const getProjectDetails = React.useCallback(
    async (projectID: number) => {
      try {
        const response = await fetchGetPromiseProjectDetail(projectID);
        setProjectDetail(response?.projectDetails ?? null);
        setsMemberOptionDetail(response?.OptionDetail ? response?.OptionDetail : null);
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchGetPromiseProjectDetail, setProjectDetail, setsMemberOptionDetail],
  );

  const updateActivitiesIsEnabled = (updates: updateProjectActivityPayload[]) => {
    if (!projectDetail) return;

    // Create a new all_activities array with the updates applied
    const updatedActivities = projectDetail.activities.map((activity) => {
      const update = updates.find((u) => u.version_id === activity.version_id);
      if (update) {
        return { ...activity, is_enabled: update.is_enabled };
      }
      return activity;
    });

    // Set the new projectDetail state with the updated all_activities
    setProjectDetail({
      ...projectDetail,
      activities: updatedActivities,
    });
  };

  const updateProjectActivity = React.useCallback(
    async (activity: updateProjectActivityPayload[]) => {
      try {
        const activityupdate = await updateProjectActivityApi(activity);
        if (activityupdate) {
          updateActivitiesIsEnabled(activity);
        }
        return activityupdate;
      } catch (error) {
        //   setError(error.message);
      }
    },
    [updateProjectActivityApi],
  );

  const addProjectActivity = React.useCallback(
    async (activity: updateProjectActivityPayload[]) => {
      try {
        const result = await addProjectActivityApi(activity);
        if (result && activity.length > 0) {
          // Re-fetch project details so the new activity appears in the list
          await getProjectDetails(activity[0].projects_id);
        }
      } catch (error) {
        //   setError(error.message);
      }
    },
    [addProjectActivityApi, getProjectDetails],
  );

  const editProjectActivity = React.useCallback(
    async (projects_id: number, version_id: number, activity_name: string) => {
      try {
        const result = await editProjectActivityApi({ projects_id, version_id, activity_name });
        if (result) {
          setProjectDetail((prev) => {
            if (!prev) return null;
            return {
              ...prev,
              activities: prev.activities.map((a) =>
                a.version_id === version_id ? { ...a, activity: activity_name } : a
              ),
            };
          });
        }
      } catch (error) {
        // setError(error.message);
      }
    },
    [editProjectActivityApi, setProjectDetail],
  );

  const addProjectMember = React.useCallback(
    async (member: createProjectUserPayloadModel) => {
      // setLoading(true, "Save data");
      try {
        const newUser = await createProjectUser(member);
        getProjectDetails(member.projects_id);
        return newUser;
      } catch (error) {
        //   setError(error.message);
      }
    },
    [createProjectUser, getProjectDetails],
  );

  const deleteProjectMember = React.useCallback(
    async (member: deleteuserInProject) => {
      // setLoading(true, "Save data");
      try {
        const returnUser = await fetchDeleteUserInProject(member);

        return returnUser;
      } catch (error) {
        //   setError(error.message);
      }
    },
    [fetchDeleteUserInProject],
  );

  const deleteProjectActivity = React.useCallback(
    async (projects_id: number, version_id: number) => {
      try {
        await deleteProjectActivityApi({ projects_id, version_id });
        // Directly remove from projectDetail so context state is consistent
        setProjectDetail((prev) => {
          if (!prev) return null;
          return {
            ...prev,
            activities: prev.activities.filter((a) => a.version_id !== version_id),
          };
        });
      } catch (error) {
        //   setError(error.message);
      }
    },
    [deleteProjectActivityApi, setProjectDetail],
  );

  const toggleMandatoryActivity = React.useCallback(
    async (projects_id: number, version_id: number) => {
      try {
        const result = await toggleMandatoryActivityApi({ projects_id, version_id });
        if (result !== null && projectDetail) {
          setProjectDetail({
            ...projectDetail,
            activities: projectDetail.activities.map((a) =>
              a.version_id === version_id ? { ...a, is_mandatory: result.is_mandatory } : a
            ),
          });
        }
      } catch (error) {
        //   setError(error.message);
      }
    },
    [toggleMandatoryActivityApi, projectDetail, setProjectDetail],
  );

  return (
    <ManageClientContext.Provider
      value={{
        projectFormType,
        setProjectFormType,
        memberOptionDetail,
        setsMemberOptionDetail,
        clientId,
        setClientID,
        clientFormType,
        setClientFormType,
        clientList,
        setClientList,
        clientDetails,
        setClientDetails,
        clientPageOption,
        setClientPageOption,
        projectOptions,
        setProjectOptions,
        projectDetail,
        setProjectDetail,
        getClientOption,
        getProjectOption,
        getClientlist,
        getClientDetails,
        addandupdateClient,
        addandupdateClientProject,
        getProjectDetails,
        updateProjectActivity,
        addProjectActivity,
        editProjectActivity,
        deleteProjectActivity,
        toggleMandatoryActivity,
        addProjectMember,
        deleteProjectMember,
      }}
    >
      {children}
    </ManageClientContext.Provider>
  );
};

export const useManageClientContext = () => useContext(ManageClientContext);

export { ManageClientContext };
